import { createTheme } from '@mantine/core';

export default createTheme({
  fontFamily: 'Poppins Regular, sans-serif',
  fontFamilyMonospace: 'Poppins Regular, monospace',
  headings: { fontFamily: 'Poppins Medium, sans-serif' },
  colors: {
    primary: [
      '#effbeb',
      '#e1f2db',
      '#c3e3b8',
      '#a3d391',
      '#88c671',
      '#76bd5b',
      '#6db950',
      '#5ba340',
      '#4f9137',
      '#407d2a'
    ],
    secondary: [
      '#f3f3f6',
      '#e4e4e5',
      '#c7c7cd',
      '#a8a8b4',
      '#8e8d9f',
      '#7d7d92',
      '#75748d',
      '#63637a',
      '#58576e',
      '#4b4b62'
    ]
  }
});